const en = {
  notFound: 'Customer not found',
  notFoundctx:
    'Please use the link provided to you via email. In case you still see this message please contact us at',
  customerDeleted: 'Customer deleted. Check link or authorizations.',
  customer_portal_tag_line: `Collect and process your documents automatically ensuring error free execution`,
  step1: 'Step 1. Select',
  step1ctx: 'Select invoices from your files.',
  step2: 'Step 2. Check',
  step2ctx: 'Check if the correct invoices were selected.',
  step3: 'Step 3. Upload',
  step3ctx: 'Upload the invoices selected.',
  login: 'Login',
  drop: 'Drop or select documents.',
  dropctx1: 'Drop documents from your computer',
  dropctx2: 'or browse',
  dropctx3: 'to select',
  selected: 'Selected documents:',
  removeAll: 'Remove All',
  upload: 'Upload documents',
  duplicateNotAllowed: 'Duplicate files are not allowed',
  limit: 'Limit of 10 documents.',
  successUpload: 'Document(s) uploaded successfully',
  errorUpload: 'Error uploading documents: ',
  useDedicatedLink:
    'You cannot upload without using your dedicated url. Please use the link we have sent you through email.',
  logout: 'Logout',
  email: {
    enterEmail: 'Enter your email to receive a confirmation code',
    enterEmailCtx: "This helps us to make sure it's you before allowing uploads",
    sendCode: 'Send code',
    checkEmail: 'Request sent successfully!',
    checkEmailCtx1: 'We have sent a 6-digit confirmation code to ',
    checkEmailCtx2: '. Please enter the code below to verify your email.',
    confirm: 'Confirm',
    code: 'Code',
    resend: "Don't have a code?",
    resendLink: 'Resend code',
    codeResent: 'Code was resent to your email',
    wrongCode: 'Wrong code entered',
  },
  loadingCustomer: 'Loading customer...',
  NeedReview: 'Need review',
  Default: 'In progress',
  Extracted: 'Extracted',
  Failed: 'Failed',
  Error: 'Error',
  Reviewed: 'Reviewed',
  Duplicate: 'Duplicate',
  'Add Document': 'Add Document',
  'Created on': 'Created on',
  Status: 'Status',
  Date: 'Date',
  Message: 'Message',
  Close: 'Close',
  'Document name': 'Document name',
  Paid: 'Paid',
  UnPaid: 'Unpaid',
  Approved: 'Approved',
  Rejected: 'Rejected',
  'Payment status': 'Payment status',
  'ERP status': 'ERP status',
  All: 'All',
  Documents: 'Documents',
  'Erp status': 'Erp status',
  Actions: 'Actions',
  'Created in ERP': 'Created in ERP',
  Yes: 'Yes',
  No: 'No',
  Pending: 'Pending',
  'View ERP details': 'View ERP details',
  'ERP Details': `ERP Details`,
  'View payment details': 'View payment details',
  'Payment Details': 'Payment Details',
  'Payment Date': 'Payment Date',
  'Transaction method': 'Transaction method',
  'Rows per page': 'Rows per page',
  of: 'of',
  upload_by_device: 'Upload by device',
  a_maximum_of_10_files_are_allowed_in_a_single_upload: `A maximum of 10 files are allowed in a single upload`,
  select_language: 'Select language',
  no_data: `No Data`,
  customer: `Customer`,
  add_a_new_document: `Add a new Document`,
  entries_per_page: `Entries per page`,
  'Drop your files here or browse through your machine.': `Drop your files here or browse through your machine.`,
  browse: `Browse`,
  upload_documents: `Upload documents`,
  upload_from_device: `Upload from device`,
  deliveryNote: `Delivery note`,
  invoice: `Invoice`,
  // Create Document
  add_valid_date: `Add valid date`,
  totalAmount: `Total amount`,
  customerCompanyName: `Customer company name`,
  customerCompanyID: `Customer company ID`,
  customerCompanyAddress: `Customer company address`,
  customerEmail: `Customer email`,
  customerCompanyName_is_required: `Company name is required`,
  customerCompanyID_is_required: `Company ID is required`,
  customerCompanyAddress_is_required: `Company address is required`,
  customerEmail_is_required: `Email is required`,
  create_document: `Create document`,
  account_information: `Account information`,
  document_information: `Document information`,
  customer_information: `Customer information`,
  supplier_information: `Supplier information`,
  vendor_information: `Vendor information`,
  items_information: `Items information`,
  taxes_information: `Taxes information`,
  account_class: `Account class`,
  document_class: `Document class`,
  optional: `Optional`,
  account_receivable: `Account receivable`,
  account_payable: `Account payable`,
  accountClass_is_required: `Account class is required`,
  documentClass_is_required: `Document class is required`,
  back: `Back`,
  next: `Next`,
  invoiceID: `Invoice ID`,
  documentNumber: `Document number`,
  poNumber: `PO number`,
  totalWithoutTax: `Total (without tax)`,
  totalTax: `Total tax`,
  taxPercentage: `Tax percentage`,
  documentDate: `Document date`,
  dueDate: `Due date`,
  invoiceId_is_required: `Invoice Id is required`,
  documentNumber_is_required: `Document number is required`,
  poNumber_is_required: `PO number is required`,
  totalWithoutTax_is_required: `Total without tax is required`,
  totalTax_is_required: `Total tax is required`,
  totalAmount_is_required: `Total amount is required`,
  taxPercentage_is_required: `Tax percentage is required`,
  deliveryNote_is_required: `Delivery note is required`,
  documentDate_is_required: `Document date is required`,
  dueDate_is_required: `Due date is required`,
  vendorCompanyName: `Company name`,
  vendorCompanyID: `Company ID`,
  vendorCompanyAddress: `Company address`,
  vendorCompanyName_is_required: `Ccompany name is required`,
  vendorCompanyID_is_required: `Company ID is required`,
  vendorCompanyAddress_is_required: `Company address is required`,
  referenceCode: `Reference code`,
  unit: `Unit`,
  unitPrice: `Unit price`,
  vatPercentage: `VAT %`,
  vat: `VAT`,
  dtoPercentage: `DTO %`,
  dto: `DTO`,
  discountPercentage: `Discount %`,
  discount: `Discount`,
  subTotalAmount: `Subtotal amount`,
  referenceCode_is_required: `Reference code is required`,
  description_is_required: `Description is required`,
  unit_is_required: `Unit is required`,
  unitPrice_is_required: `Unit price is required`,
  quantity_is_required: `Quantity is required`,
  vatPercentage_is_required: `VAT percentage is required`,
  vat_is_required: ` VAT is required`,
  dtoPercentage_is_required: `DTO percentage is required`,
  dto_is_required: `DTO is required`,
  discountPercentage_is_required: ` Discount percentage is required`,
  discount_is_required: `Discount is required`,
  subTotalAmount_is_required: `Sub total amount is required`,
  amount_is_required: `Amount is required`,
  delete_item: `Delete item`,
  update_item: `Update item`,
  delete_items: `Delete items`,
  taxes: `Taxes`,
  baseAmount: `Base amount`,
  add_tax: `Add tax`,
  submit: `Submit`,
  reset: `Reset`,
  atleast_one_item_is_required: `Atleast one item is required`,
  atleast_one_tax_is_required: `Atleast one tax is required`,
  submit_and_create_new_document: `Submit and create new document`,
  baseAmount_is_required: `Base amount is required`,
  vendorEmailAddress: `Email address`,
  vendorEmail_is_required: `Email address is required`,
  add_item: `Add item`,
  delete_approval: `Are you sure you want to delete this`,
  upload_document: `Upload document`,
  document_is_required: `Document is required`,
  email_invalid: `Email must be a valid email address`,
  quantity: `Quantity`,
  amount: `Amount`,
  actions: `Actions`,
  Edit: `Edit`,
  Cancel: `Cancel`,
  description: `Description`,
  cancel_button: `Cancel`,
  delete: `Delete`,
  tax: `Tax`,
  delete_tax: `Delete tax`,
  delete_taxes: `Delete taxes`,
  only_one_document_is_allowed_to_upload: `Only one document allowed to be upload`,
  document_created_successfully: `Document created successfully`,
  update_tax: `Update tax`,
  my_information: `My information`,
  emailAddress: `Email address`,
  companyAddress: `Company address`,
  companyID: `Company ID`,
  companyName: `Company name`,
  companyName_is_required: `Company name is required`,
  companyID_is_required: `Company ID is required`,
  companyAddress_is_required: `Company address is required`,
  email_is_required: `Email address is required`,
  dueDate_should_be_greater_than_documentDate: `Due date should be greater than document date`,
  documentDate_should_be_less_than_dueDate: `Document date should be less than due date`,
  'tax_amount_not_%': 'Tax (amount)',
  document_details: `Document Details`,
  date_details: `Date Details`,
  logo_url: `Logo URL`,
  please_enter_your_information: `Please enter your information`,
  please_enter_supplier_information: `Please enter information of your supplier who will receive this document.`,
  'Approval Process': `Approval process`,
  tax_must_be_number: `Tax is required and must be number`,
  discount_must_be_number: `Discount must be number`,
  unitPrice_must_be_number: `Unit price is required and must be number`,
  quantity_must_be_number: `Quantity is required and must be number`,
  baseAmount_must_be_number: `Base amount is required and must be number`,
  tax_is_required: `Tax is required`,
  tax_type: `Tax type`,
  tax_type_is_required: `Tax type is required`,
  total_discount: `Total discount`,

  finance_screen: {
    email_text: `Your own dedicated email to send the documents`,
    docs_processed: `Processed Documents`,
    email_csv_export: `Email CSV Export`,
    selected_files: `Selected file(s)`,
    remove_all: `Remove all`,
    upload_files: `Upload files`,
    duplicate_files_are_not_allowed: `Duplicate Files are not Allowed`,
    files_cannot_be_more_than_10: `Files cannot be more than 10`,
    document_uploaded_successfully: `Document Uploaded Successfully`,
    extract_now: `Extract now`,
    all: `All`,
    Invoice: `Invoices`,
    PurchaseOrder: `Purchase Order`,
    credit_memo: `Credit Memo`,
    delivery_note: `Delivery Note`,
    reciepts: `Receipts`,
    processed_on: `Processed on`,
    DeliveryNote: `Delivery Note`,
    Reciepts: `Receipts`,
    filename: `File Name`,
    processed_at: `Processed At`,
    output: `Output`,
    status: `Status`,
    creeated_in_erp: `Created in ERP`,
    no_data: `No data`,
    dense: `Dense`,
    rows_per_page: `Rows per page:`,
    retry_button: `Retry`,
    yes_button: `Yes`,
    no_button: `No`,
    start_date: `Start Date`,
    end_date: `End Date`,
    search: `Search`,
    document_upload_unsuccessful: `Document Upload Failed`,
    'Document not supported': `Document not supported`,
    'Number of pages exceed': 'Number of pages exceeded',
    'Limit Exceed': `Document Limit Exceeded`,
    document_name: `Document Name`,
    SimpleNote: `Simple Note`,
    WorkContract: `Work Contract`,
    Payroll: `Payroll`,
    DNI: `DNI`,
    Passport: `Passport`,
    NIE: `NIE`,
    SimulatedInvoice: `Simulated Invoice`,
    output_data: `Output data`,
    CreditNote: `Credit Note`,
    failed_to_fetch_document_version_id: `Failed to fetch Document Version ID`,
  },
  status: {
    in_process: `In process`,
    processed: `Processed`,
    failed: `Failed`,
    error: `Error`,
    need_review: `Need Review`,
    reviewed: `Reviewed`,
    duplicate: `Duplicate`,
    connected: `Connected`,
    not_connected: `Not connected`,
    success: `Success`,
    plan: `free`,
    'My profile': `My profile`,
    Logout: `Logout`,
    'Email must be a valid email address': `Email must be a valid email address`,
    'Email is required': `Email is required`,
    'Name is required': `Name is required`,
    registration_number_required: `Registration number is required`,
    registration_number_validation2: `Registration number is invalid`,
    registration_number_validation1: `Registration number cannot be more than 20 characters`,
    iban_validation_2: `IBAN is invalid`,
    iban_validation_1: `IBAN cannot be more than 24 characters`,
    'My Profile': `My Profile`,
    name: `Name`,
    Email: `Email`,
    registration_number: `Registration number`,
    account_holder_name: `Account holder name`,
    iban: `IBAN`,
    'Go back': `Go back`,
    Save: `Save`,
    Invoice: `Invoice`,
    PurchaseOrder: `Purchase Order`,
    DeliveryNote: `Delivery Note`,
  },
  Filters: `Filters`,
  'Document status': `Document status`,
  'Approval status': `Approval status`,
  'ERP integrated': `ERP integrated`,
  'Include deleted documents': `Include deleted documents`,
  'Clear all': `Clear all`,
  'Search ...': `Search ...`,
  'Create Purchase order': `Create Purchase order`,
  account_holder_name: `Account Holder Name`,
  registration_number: `Registration number`,
  name: `Name`,
  Email: `Email`,
  iban: `IBAN`,
  'Upload purchase order': `Upload purchase order`,
  'Upload Purchase Order': `Upload Purchase Order`,
  'Delete document': `Delete document`,
  'Are you sure you want to delete this document?': `Are you sure you want to delete this document?`,
  'Are you sure you want to delete all documents?': `Are you sure you want to delete all documents?`,
  'Are you sure you want to delete these documents?': `Are you sure you want to delete these documents?`,
  deleted_document: `Deleted document`,
  NeedApproval: 'Need Approval',
  Onboarding: `Onboarding`,
  'Complete Your Profile': `Complete Your Profile`,
  "You're almost done! Complete any missing information to finish your setup.": `You're almost done! Complete any missing information to finish your setup.`,
  'Bank Details': `Bank Details`,
  'Verify Your Bank Details': `Verify Your Bank Details`,
  'Review your bank information and fill in any gaps for smooth transactions.': `Review your bank information and fill in any gaps for smooth transactions.`,
  Profile: `Profile`,
  'Supplier Updated': `Supplier Updated`,
  something_went_wrong: 'Something went wrong',
  'Company ID': 'Company ID',
  'Onboarding completed': 'Onboarding completed',
  Finish: 'Finish',
  Continue: 'Continue',
  Back: 'Back',
  'Email must be a valid email address': 'Email must be a valid email address',
  'Email is required': 'Email is required',
  'Name is required': 'Name is required',
  'Nationality is required': 'Nationality is required',
  'Tax Identification Number is required': 'Tax Identification Number is required',
  'IBAN cannot be more than 24 characters': `IBAN cannot be more than 24 characters`,
  'IBAN is required': `IBAN is required`,
  'IBAN is not valid': `IBAN is not valid`,
  account_holder_name_required: `Account holder name is required`,
  registration_number_required: `Registration number is required`,
  action: 'Action',
  'View document': 'View document',
  not_document_owner: 'You cannot delete this document',

  // Payment Gateway
  payments: `Payments`,
  payment_gateways: `Payment Gateways`,
  payment_gateway_not_connected: `Payment gateway not connected`,
  add_payment_gateway: `Add payment gateway`,
  connect: `Connect`,
  disconnect: `Disconnect`,
  in_process: `In process`,
  new_payment_gateway_button_text: `Connect new Payment Gateway`,
  payment_gateway_disconnected_successfully: `{{paymentGatewayName}} disconnected successfully`,
  payment_gateway_connection_request_sent: `{{paymentGateway}} connected request sent`,
  disconnect_payment_gateway: `Disconnect {{paymentGateway}}`,
  disconnect_payment_gateway_warning: `Are you sure you want to disconnect {{paymentGateway}}, once disconnected all configurations will be lost`,
  paymentgateway_notallowed_toconnect_multiplegateways: `Connecting multiple payment gateways is not allowed`,
  paymentgateway_not_found: `Payment gateway not found`,
  make_payment: `Make payment`,
  'payment_all_selected_document(s)_workflow_shouldbe_approved':
    'Payment for all selected document(s) should be approved in the workflow.',
  payment_supplier_vendorid_not_found: `Vendor ID not found`,
  payment_method: `Payment method`,
  payment_details: `Payment details`,
  sub_total: `Sub total`,
  process_payment: `Process payment`,
  'Bnak To Bank': `Bank to Bank`,
  balance: `Balance`,
  From: `From`,
  To: `To`,
  vendorCompanyId: `Company ID`,
  'fee_0%': `Fee 0%`,
  total: `Total`,
  payment_made_successfully: `Payment made successfully`,
  transaction_id: `Transaction ID`,
  created_by: `Created by`,
  created_on: `Created on`,
  invoice_payments: `Invoice payments`,
  transacted_by: `Transaction by`,
  transacted_on: `Transacted on`,
  details: `Details`,
  company_id: `Company ID`,
  no_payments_found: `No payments found`,
  'payment_all_selected_document(s)_shouldbe_processed_or_reviewed':
    'All selected documents should be processed or reviewed',
  Success: `Success`,
  'Customer Updated': 'Customer Updated',
  denied_payment: `Payment denied`,
  payment_account_class_should_be_account_receivable: `Account class should be account receivable`,
  payment_supplier_iban_not_found: `Supplier IBAN not found`,
  payment_supplier_account_info_not_found: `Supplier account information not found`,
  payement_customer_notfound: `Customer not found`,
  payement_customer_deleted: `Customer deleted`,
  payement_customer_incomplete_onboarding: `Customer onboarding incomplete`,
  payment_gateway_account_not_activated: `Payment gateway account not activated`,
  payment_select_not_deleted_document: `Deleted document payment cannot be made`,
  payment_account_class_should_be_receiveable: `Account class should be account receivable`,
  'payment_all_selected_document(s)_type_shouldbe_invoice': `All selected document(s) type should be invoice`,
  payment_invoice_amout_greaterthan_zero: `Payment amount should be greater than zero`,
  Process: `Process`,
  PartialPaid: `Partial paid`,
  payment_you_have_insufficient_balance_to_complete_transaction: `You have insufficient balance to complete transactions`,
  source: `Source`,
  method: `Method`,
  processed_by_and_date: `Processed by & date`,
  BankTransfer: `Bank transfer`,
  coming_soon: `Coming soon`,
  vendor_currency_notmatch_payeeaccount_currency: `Vendor currency does not match with payee currency`,
  tax_info_not_required: `Tax information is not required as it is already included in items information. You may, however, specify withholding tax (WHT) if applicable.`,
  // Permissions
  access_forbidden: `Access forbidden`,
  you_dont_have_permission_to_access_this_page: `You don't have permission to access this page`,
  go_to_homepage: `Go to homepage`,
  unexpected_error: `An erro has occurred`,
  companyID_cannot_contain_comma: `Company ID cannot contain comma`,
  Currency: `Currency`,
  currency_is_required: `Currency is required`,
  no_: 'No.',
  document_date: 'Document date',
  vendor_address: 'Vendor address',
  vendor_id: 'Vendor ID:',
  code: 'Code',
  purchase_order: 'Purchase order',
  delivery_note: 'Delivery note',
  unit_price: 'Unit price',
  subtotal: 'Subtotal',
  total_without_tax: 'Total (without tax)',
  total_tax: 'Total tax',
  of_: 'of',
  'Create Purchase Order': 'Create Purchase Order',
  'Catalog item': 'Catalog item',
  WHT: 'Withholding Tax',
  VAT: 'VAT',
  address: `Address`,
  // Notes
  notes: `Notes`,
  note: `Note`,
  view_notes: `View notes`,
  add: `Add`,
  close: `Close`,
  no_data_found: `No data found`,
  resource_not_found: `Resource not found`,
  add_filter: `Add filter`,
  document_filters: `Document filters`,
  field_name: `Field name`,
  field_value: `Field value`,
  field_value_is_required: `Field value is required`,
  field_name_is_required: `Field name is required`,
  view_details: `View details`,
  delete_note_title: `Delete note`,
  add_a_note: `Add a note`,
  no_notes_found: `No notes found`,
  note_is_required: `Note is required`,
  note_validation_max_length: `Note cannot be more than 1000 characters`,
  notes_length_exceed: `Notes length exceeded`,
  note_deletedBy_deletedOn: `Deleted by {{deletedBy}} on {{deletedOn}}`,
  document_note_not_owner: `You are not the owner of this note and cannot perform this action.`,
  error_parsing_customer_info: `Error parsing customer information`,
  // Legal Representative
  legal_representative_details: `Legal Representative details`,
  verify_your_legal_representative_details: `Verify your legal representative details`,
  first_name: `First name`,
  last_name: `Last name`,
  document_type: `Document type`,
  document_code: `Document code`,
  street_number: `Street number`,
  street: `Street`,
  number: `Number`,
  municipality: `Municipality`,
  province: `Province`,
  zipCode: `Zip code`,
  country: `Country`,
  dni_number: 'DNI number',
  id_card_front_document: 'DNI card (Front)',
  id_card_back_document: 'DNI card (Back)',
  upload_front_id_card: 'Upload front of DNI card',
  upload_back_id_card: 'Upload back of DNI card',
  legal_representative_information: `Legal Representative Information`,
  general_information: `General Information`,
  discounts_information: `Discounts information`,
  companyid_must_be_unique: `Company ID must be unique`,
  signature: `Signature`,
  upload_signature: `Upload signature`,
  remove: `Remove`,
  total_before_discount: `Total before discount`,
  total_after_discount: `Total after discount`,
  'attach_support_document_(optional)': ` Attach support document (optional)`,
  comments: `Comments`,
  field_name_cannot_exceed_characters: `{{fieldName}} cannot exceed {{number}} characters.`,
  failed_to_fetch_notification: `Failed to fetch notification`,
  new_app_verion_available: 'Please refresh the page to get the latest version of Dost.',
  update_available: "We've made some improvements",
  refresh: 'Refresh',
  phone_number: `Phone number`,
  locality: `Locality`,
  region: `Region`,
  customer_address_info: `Customer address information`,
  basic_information: `Basic information`,
  powered_sage: 'Powered by CONTROL AI SOLUTIONS',
  // duplicate-document-number dialog (existing)
  document_number_already_exists: `Document number already exists`,
  document_number_exists_message: `A document has already been assigned this document number:{{documentNumber}}`,
  would_you_like_to_generate_new_document_number: `Would you like to generate a new document number`,
  regenerate_document_number: `Regenerate document number`,
  document_number_regenerated_successfully: `Document number regenerated successfully`,

  // section headings
  verifactu_simplified_invoice: `Verifactu simplified invoice`,
  sii_simplified_invoice: `SII simplified invoice`,
  verifactu_regular_invoice: `Verifactu regular invoice`,
  sii_regular_invoice: `SII regular invoice`,
  verifactu_debit_note: `Verifactu debit note`,
  sii_credit_note: `SII credit note`,
  verifactu_credit_note: `Verifactu credit note`,
  sii_corrective_invoice: `SII corrective invoice`,
  verifactu_corrective_invoice: `Verifactu corrective invoice`,
  sdi_regular_invoice: `SDI regular invoice`,
  corrective_invoice: `Corrective invoice`,
  sdi_credit_note: `SDI credit note`,
  replacement_invoice: `Replacement invoice`,
  recurring_invoice: `Recurring invoice`,
  recurring_invoice_information: `Recurring invoice information`,

  // document info fields
  ExpenseCategory: `Expense category`,
  rectificationReason: `Rectification reason`,
  SpainCorrectionCode: `Correction code`,

  // company / contact (shared between customer & vendor)
  companyEmail: `Email`,
  email_address: `Email Address`,

  // customer address breakdown
  CustomerCompanyStreet: `Company Street`,
  CustomerCompanyStreetNumber: `Company Street Number`,
  CustomerCompanyLocality: `Company Locality`,
  CustomerCompanyRegion: `Company Region`,
  CustomerCompanyZipCode: `Company Zip Code`,
  CustomerCountry: `Country`,
  customerCompanyStreet_is_missing: `Company street is missing`,
  customerCompanyStreetNumber_is_missing: `Company street number is missing`,
  customerCompanyLocality_is_missing: `Company locality is missing`,
  customerCompanyRegion_is_missing: `Company region is missing`,
  customerCompanyZipCode_is_missing: `Company zip code is missing`,

  // vendor address breakdown
  VendorCompanyStreet: `Company Street`,
  VendorCompanyStreetNumber: `Company Street Number`,
  VendorCompanyLocality: `Company Locality`,
  VendorCompanyRegion: `Company Region`,
  VendorCompanyZipCode: `Company Zip Code`,
  VendorCountry: `Country`,

  // buttons / status
  configuration: `Configuration`,

  // stacked layout (new UI)
  create_compliance_standard_document: `Create {{complianceStandard}} {{documentType}}`,
  customize_invoice_sequencing: `Customize invoice sequencing`,
  configure_document_series: `Configure document series`,
  regular_invoice: `Regular Invoice`,
  verifactu: `Verifactu`,
  sdi: `SDI`,
  sii: `SII`,
  logo_url_missing: `Logo URL missing`,
  edit_vendor_information: `Edit my information`,
  fill_vendor_details: `Fill in the my details to add them to your list`,
  add_logo_url: `Add logo URL`,
  vendor_email_address: `Email address`,
  company_street: `Company street`,
  company_street_number: `Company street number`,
  company_locality: `Company locality`,
  company_zip_code: `Company zip code`,
  company_region: `Company region`,
  add_po_number: `Add PO number`,
  po_number: `PO number`,
  add_delivery_note: `Add delivery note`,
  add_pec_code: `Add PEC code`,
  pec_code: `PEC code`,
  pec_code_is_missing: `PEC code is missing`,
  add_destination_code: `Add destination code`,
  destination_code: `Destination code`,
  destination_code_is_missing: `Destination code is missing`,
  invoice_information: `Invoice information`,
  purchase_order_information: `Purchase order information`,
  delivery_note_information: `Delivery note information`,
  connected_documents: `Connected documents`,
  search_or_add_a_new_customer: `Search or add a new customer`,
  'no_items_added-click_on_add__line_item_to_add_items': `No items added — click on "Add line item" to add items`,
  line_items: `Line items`,
  add_line_item: `Add line item`,
  search_by_reference_code_or_description_or_add_new_item: `Search by reference code or description, or add a new item`,
  search_by_reference_code_description_keywords: `Search by reference code, description, keywords`,
  add_discount: `Add discount`,
  also_add_this_item_to_catalog: `Also add this item to catalog`,
  total_breakdown: `Total breakdown`,
  wht_tax: `WHT tax`,
  total_amount: `Total amount`,
  additional_options: `Additional options`,
  additional_tax: `Additional tax`,
  support_documents: `Support document`,
  supporting_documents: `Supporting Document`,
  discount_type: `Discount type`,
  percentage: `Percentage`,
  base_amount: `Base amount`,
  make_recurring_invoice: `Make recurring invoice`,
  preview_pdf: `Preview PDF`,
  cancel: `Cancel`,
  monthly: `Monthly`,
  yearly: `Yearly`,
  taxes_permission_required: `Taxes permission required`,
  add_new_tax: `Add New Tax`,
  edit_tax: `Edit Tax`,
  rate: `Rate`,
  is_withholding_tax: `Is Withholding Tax`,
  VAT_label: `VAT - Value Added Tax`,
  IGIC_label: `IGIC - Canary Island Tax`,
  IRPF_label: `IRPF - Personal Income Tax`,
  WHT_label: `WHT - Withholding Tax`,
  tax_type_required: `Tax type is required`,
  rate_required: `Rate is required`,
  rate_min: `Rate must be greater than or equal to 0`,
  tax_created_success: `Tax created successfully`,
  tax_updated_success: `Tax updated successfully`,
  error_fetching_tax_data: `Error fetching tax data`,
  update: `Update`,

  // customer edit modal
  edit_customer_information: `Edit customer information`,
  fill_customer_details: `Fill in the customer details to add them to your list`,
  customer_address: `Company address`,
  customer_company_name: `Company name`,
  customer_company_ID: `Company ID`,
  customer_email_address: `Email address`,
  customerCurrency_is_required: `Currency is required`,
  currency: `Currency`,
  delete_customer_title: `Are you sure you want to remove supplier?`,
  delete_customer_warning: `Removing the supplier wont delete them but remove them from you invoice`,
  delete_vendor_title: `Are you sure you want to remove vendor?`,
  delete_vendor_warning: `Removing the vendor wont delete them but remove them from your invoice`,
  item_delete_title: `Are you sure you want to delete this item?`,
  item_delete_warning: `Deleting the item will remove it from your invoice`,

  // additional options
  item_level_discount_already_added: `An item-level discount is already applied. Disable item discounts before adding a document-level discount.`,

  // document series modal (new UI)
  customize_invoice_sequencing_number: `Customize invoice sequencing number`,
  sequence_number_sub_text: `Create a new invoice sequencing rule, or view existing & previous sequencing rules`,
  add_new_sequencing_rule: `Add new sequencing rule`,
  add_new_sequence_rule_description: `Adding a new sequence rule replaces the currently active rule`,
  add_new_rule: `Add new rule`,
  starting_number: `Starting number`,
  delete_series: `Delete series?`,
  delete_series_warning: `Deleting this series will remove it from your document`,
  deactive_series: `Deactive series`,
  deactivate: `Deactivate`,
  deactivate_sequence_title: `Deactivate this sequence?`,
  deactivate_sequence_note: `Note: You'll need an active sequence to create new invoices.`,
  add_new: `Add New`,
  add_series_warning: `Adding a new series will replace the active one. Continue?`,
  select_or_type_vendor_company_id: `Select vendor company ID`,
  invoicecompliance_module_not_enabled: `Invoice compliance module is not enabled`,
  please_enter_company_name: 'Please enter a company name',
  please_select_company_id: 'Please select a company ID',
  please_select_country: 'Please select a country',
  please_select_currency: 'Please select a currency',
  tax_percentage_is_required: 'Tax percentage is required',
  click_to_upload: `Click to upload`,
  no_invoice_number: `No invoice number`,
  file_size_exceeds: `File size exceeds 5MB`,
  'supported_document.pdf': `supported_document.pdf`,
  delivery_note_required: `Delivery Note is required`,
  discount_amount: `Discount amount`,
  reference_code: `Reference code`,
  tax_amount: `Tax (amount)`,
  edit_my_information: `Edit my information`,
  fill_my_details: `Fill in the details to add them to your list`,
  edit_supplier_information: `Edit supplier information`,
  fill_supplier_details: `Fill in the supplier details to add them to your list`,

  'Basic Information': `Basic Information`,
  'Peppol Inbox Configuration': `Peppol Inbox Configuration`,

  peppol_inbox_configuration: {
    add_configuration: `Add Configuration`,
    edit_configuration: `Edit Configuration`,
    create: `Create`,
    company_id: `Company ID`,
    country: `Country`,
    peppol_participant_id: `Peppol Participant ID`,
    scheme_id: `Scheme ID`,
    select_company_id: `Select Company ID`,
    company_id_required: `Company ID is required`,
    country_required: `Country is required`,
    peppol_participant_id_required: `Peppol Participant ID is required`,
    scheme_id_required: `Scheme ID is required`,
    created_successfully: `Configuration created successfully`,
    updated_successfully: `Configuration updated successfully`,
    deleted_successfully: `Configuration deleted successfully`,
    delete_configuration_title: `Delete Configuration`,
    delete_configuration_warning: `Are you sure you want to delete this Peppol configuration?`,
    peppol_inbox_details_for_company_id: `Peppol Inbox Details for Company ID`,
  },
  // Compliance Legal Representative
  legal_representative: `Legal Representative`,
  legal_representative_created: `Legal representative created successfully`,
  legal_representative_updated: `Legal representative updated successfully`,
  role: `Role`,
  address_information: `Address information`,
  additional_documents: `Additional documents`,
  View: `View`,
  permission_not_granted: `You don't have permission to perform this action`,

  // Legal representative validation
  legal_rep_email_required: `Email is required`,
  legal_rep_email_invalid: `Email must be a valid email address`,
  legal_rep_role_required: `Role is required`,
  legal_rep_country_required: `Country is required`,

  // Unsaved changes dialog
  unsaved_changes: `Unsaved changes`,
  doc_configuration_unsaved_changes_warning: `You have unsaved changes. Do you want to save before switching tabs?`,
  unsaved_changes_confirm: `Save and continue`,
  unsaved_changes_cancel: `Stay`,
};

export default en;
